/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

/* eslint-disable max-len */
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule as MatDialogModuleV3 } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule } from '@angular/router';
import { AdminAddMemberComponent } from '@app/app/page-modules/admin/components/members/admin-member-list/admin-add-member/admin-add-member.component';
import { MemberInfoDialogComponent } from '@app/app/page-modules/admin/components/members/admin-member-list/member-info-dialog/member-info-dialog.component';
import { V3AdminActionButtonsComponent } from '@app/app/page-modules/admin/components/members/admin-member-list/v3-admin-action-buttons/v3-admin-action-buttons.component';
import { V3AdminMemberListComponent } from '@app/app/page-modules/admin/components/members/admin-member-list/v3-admin-member-list/v3-admin-member-list.component';
import { V3AdminMemberTableComponent } from '@app/app/page-modules/admin/components/members/admin-member-list/v3-admin-member-table/v3-admin-member-table.component';
import { V3MemberInfoDialogComponent } from '@app/app/page-modules/admin/components/members/admin-member-list/v3-member-info-dialog/v3-member-info-dialog.component';
import { AudienceChipListComponent } from '@app/app/page-modules/admin/components/members/audience-chip-list/audience-chip-list.component';
import { V3AdminMembersControlPanelComponent } from '@app/app/page-modules/admin/components/members/v3-admin-member-control-panel/v3-admin-member-control-panel.component';
import { V3InviteMemberComponent } from '@app/app/page-modules/admin/components/members/v3-invite-member/v3-invite-member.component';
import { V3TargetAudienceSectionComponent } from '@app/app/page-modules/admin/components/members/v3-target-audience-section/v3-target-audience-section.component';
import { V3AdminMembersComponent } from '@app/app/page-modules/admin/components/v3-members/v3-members.component';
import { MEMBERS_DATA_SERVICE } from '@app/app/page-modules/admin/services/members/members-data.service';
import { MENTOR_MENTEE_DATA_SERVICE } from '@app/app/page-modules/admin/services/mentor-mentee/mentor-mentee-data.service';
import { EditableSectionTitleComponent } from '@app/app/page-modules/diagnostics/components/editor/report-360/editable-section-title/editable-section-title.component';
import { FeedbackProvidersSectionComponent } from '@app/app/page-modules/diagnostics/components/editor/report-360/feedback-providers-section/feedback-providers-section.component';
import { FeedbackQuestionSectionComponent } from '@app/app/page-modules/diagnostics/components/editor/report-360/feedback-question-section/feedback-question-section.component';
import { FeedbackStatsSectionComponent } from '@app/app/page-modules/diagnostics/components/editor/report-360/feedback-stats-section/feedback-stats-section.component';
import { ReportTopActionsComponent } from '@app/app/page-modules/diagnostics/components/editor/report/report-top-actions/report-top-actions.component';
import { CompetencyScaleComponent } from '@app/app/page-modules/diagnostics/components/view/competency-scale/competency-scale.component';
import { ProvidersSectionComponent } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/feedback/providers-section/providers-section.component';
import { ChoiceResultsTablePreviewComponent } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/feedback/questions-section/question-answer-choise/choice-results-table-preview/choice-results-table-preview.component';
import { QuestionAnswerChoiceComponent } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/feedback/questions-section/question-answer-choise/question-answer-choice.component';
import { QuestionAnswerSliderComponent } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/feedback/questions-section/question-answer-slider/question-answer-slider.component';
import { QuestionAnswerTextComponent } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/feedback/questions-section/question-answer-text/question-answer-text.component';
import { QuestionsSectionComponent } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/feedback/questions-section/questions-section.component';
import { ResultsRangeChartComponent } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/feedback/results-range-chart/results-range-chart.component';
import { StatsSectionComponent } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/feedback/stats-section/stats-section.component';
import { DiagnosticsViewReportDialog360Component } from '@app/app/page-modules/diagnostics/components/view/diagnostics-view-report/report-dialog-360/report-dialog-360.component';
import { PublicBadgeContentComponent } from '@app/app/page-modules/folio/components/view/public-badge-content/public-badge-content-new.component';
import { V3FolioMasonryCardTagsComponent } from '@app/app/page-modules/folio/components/view/shared/masonry-section/v3-folio-masonry-card/v3-folio-masonry-card-tags/v3-folio-masonry-card-tags.component';
import { V3FolioMasonryCardComponent } from '@app/app/page-modules/folio/components/view/shared/masonry-section/v3-folio-masonry-card/v3-folio-masonry-card.component';
import { ApiLtiCourseBadgeDataService } from '@app/app/page-modules/lti/services/badges/api-lti-course-badge-data.service';
import { PlaylistMetricsTableDialogComponent } from '@app/app/page-modules/pages/components/edit/analytics/details-dialog/playlist-metrics-table-dialog.component';
import { EventSearchComponent } from '@app/app/page-modules/pages/components/edit/analytics/event-search/event-search.component';
import { PageAnalyticsComponent } from '@app/app/page-modules/pages/components/edit/analytics/page-analytics.component';
import { UpcomingEventCardComponent } from '@app/app/page-modules/pages/components/shared/upcoming-event-card/upcoming-event-card.component';
import { PlaylistPrintReportComponent } from '@app/app/page-modules/playlist/components/view/content/print-report/print-report.component';
import { PlaylistReportComponent } from '@app/app/page-modules/playlist/components/view/content/report/report.component';
import { REVIEWS_DATA_SERVICE } from '@app/app/page-modules/reviews/services/data.service';
import { MembersReIndexButtonComponent } from '@app/app/shared/components-v3/members-re-index-button/members-re-index-button.component';
import { AddFrameworkTagsDialogComponent } from '@app/app/shared/components/add-framework-tags-dialog/add-framework-tags-dialog.component';
import { AdvancedImageCropDialogComponent } from '@app/app/shared/components/advanced-image-crop-dialog/advanced-image-crop-dialog.component';
import { AnalyticsHelpComponent } from '@app/app/shared/components/analytics/analytics-help/analytics-help.component';
import { CompletionUserCountChartComponent } from '@app/app/shared/components/analytics/completion-user-count-chart/completion-user-count-chart.component';
import { CourseEngagementsChartComponent } from '@app/app/shared/components/analytics/course-engagements-chart/course-engagements-chart.component';
import { DailyEnrollmentChartComponent } from '@app/app/shared/components/analytics/daily-enrollment-chart/daily-enrollment-chart.component';
import { DailyViewsChartComponent } from '@app/app/shared/components/analytics/daily-views-chart/daily-views-chart.component';
import { DeviceTypeChartComponent } from '@app/app/shared/components/analytics/device-type-chart/device-type-chart.component';
import { MostActiveViewersChartComponent } from '@app/app/shared/components/analytics/most-active-viewers-chart/most-active-viewers-chart.component';
import { MostCompletionsChartComponent } from '@app/app/shared/components/analytics/most-completions-chart/most-completions-chart.component';
import { MostEngagedUsersChartComponent } from '@app/app/shared/components/analytics/most-engaged-users-chart/most-engaged-users-chart.component';
import { MostEngagementsChartComponent } from '@app/app/shared/components/analytics/most-engagements-chart/most-engagements-chart.component';
import { AudioRecorderComponent } from '@app/app/shared/components/audio-recorder/audio-recorder.component';
import { BadgeImageComponent } from '@app/app/shared/components/badge-image/badge-image.component';
import { SimpleBarChartComponent } from '@app/app/shared/components/carts/simple-bar-chart/simple-bar-chart.component';
import { SimpleHorizontalBarChartComponent } from '@app/app/shared/components/carts/simple-horizontal-bar-chart/simple-horizontal-bar-chart.component';
import { SimplePieChartComponent } from '@app/app/shared/components/carts/simple-pie-chart/simple-pie-chart.component';
import { ControlPanelFilterChipsComponent } from '@app/app/shared/components/control-panel-filter-chips/control-panel-filter-chips.component';
import { CustomSelectComponent } from '@app/app/shared/components/custom-select/custom-select.component';
import { DatapointSelectionDialogComponent } from '@app/app/shared/components/datapoint-selection-dialog/datapoint-selection-dialog.component';
import { DatePickerComponent } from '@app/app/shared/components/date-picker/date-picker.component';
import { DateRangePickerComponent } from '@app/app/shared/components/date-range-picker/date-range-picker.component';
import { EventCardsRemindersComponent } from '@app/app/shared/components/event-reminders/event-reminders.component';
import { EventCardsTicketsComponent } from '@app/app/shared/components/event-tickets/event-tickets.component';
import { FileDropzoneComponent } from '@app/app/shared/components/file-dropzone/file-dropzone.component';
import { ExportBtnComponent } from '@app/app/shared/components/filters/export-btn/export-btn.component';
import { DiagnosticsViewGroupQuestionTypeComponent } from '@app/app/shared/components/group-question-type/group-question-type.component';
import { DiagnosticsViewListQuestionTypeComponent } from '@app/app/shared/components/list-question-type/list-question-type.component';
import { MemberSearchAutocompleteComponent } from '@app/app/shared/components/member-search-autocomplete/member-search-autocomplete.component';
import { MenteeSearchAutocompleteComponent } from '@app/app/shared/components/mentee-search-autocomplete/mentee-search-autocomplete.component';
import { JobsTimelineDialogComponent } from '@app/app/shared/components/mentor-mentee/jobs-timeline-dialog/jobs-timeline-dialog.component';
import { MentorMenteeTableComponent } from '@app/app/shared/components/mentor-mentee/mentor-mentee-table/mentor-mentee-table.component';
import { MentorSearchDialogComponent } from '@app/app/shared/components/mentor-mentee/mentor-search-dialog/mentor-search-dialog.component';
import { PaginationBlockComponent } from '@app/app/shared/components/pagination-block/pagination-block.component';
import { PaginationComponent } from '@app/app/shared/components/pagination/pagination.component';
import { PdfPagesRendererComponent } from '@app/app/shared/components/pdf-pages-renderer/pdf-pages-renderer.component';
import { PolarChartPreviewComponent } from '@app/app/shared/components/resource-preview/chart-preview/polar-chart/polar-chart-preview.component';
import { RadarChartPreviewComponent } from '@app/app/shared/components/resource-preview/chart-preview/radar-chart/radar-chart-preview.component';
import { FormAiAssistantComponent } from '@app/app/shared/components/resource-preview/form-preview/form-ai-assistant/form-ai-assistant.component';
import { FormPreviewBookingComponent } from '@app/app/shared/components/resource-preview/form-preview/form-booking/form-booking.component';
import { FormPreviewCheckboxComponent } from '@app/app/shared/components/resource-preview/form-preview/form-checkbox/form-checkbox.component';
import { FormPreviewFileUploadComponent } from '@app/app/shared/components/resource-preview/form-preview/form-file-upload/form-preview-file-upload.component';
import { FormPreviewPrivateNoteComponent } from '@app/app/shared/components/resource-preview/form-preview/form-private-note/form-private-note.component';
import { ReviewCommentPreviewComponent } from '@app/app/shared/components/resource-preview/form-preview/review-comment-preview/review-comment-preview.component';
import { ShareBadgeUrlComponent } from '@app/app/shared/components/share-badge-url/share-badge-url.component';
import { ShareEventComponent } from '@app/app/shared/components/share-event/share-event.component';
import { SkeletonBadgeComponent } from '@app/app/shared/components/skeleton-view/skeleton-badge/skeleton-badge.component';
import { SkeletonPagesItemComponent } from '@app/app/shared/components/skeleton-view/skeleton-pages-item/skeleton-pages-item.component';
import { SkeletonSmallCardItemComponent } from '@app/app/shared/components/skeleton-view/skeleton-small-card-item/skeleton-small-card-item.component';
import { DiagnosticsViewSliderQuestionTypeComponent } from '@app/app/shared/components/slider-question-type/slider-question-type.component';
import { StudentSearchAutocompleteComponent } from '@app/app/shared/components/student-search-autocomplete/student-search-autocomplete.component';
import { VideoRecorderComponent } from '@app/app/shared/components/video-recorder/video-recorder.component';
import { AnimateOnScrollDirective } from '@app/app/shared/directives/animate-on-scroll.directive';
import { CamelToReadablePipe } from '@app/app/shared/pipes/camel-to-readable.pipe';
import { DateFormatPipe } from '@app/app/shared/pipes/date-format.pipe';
import { IsNonEmptyEditorContentPipe } from '@app/app/shared/pipes/is-non-empty-editor-content.pipe';
import { StringToArrayPipe } from '@app/app/shared/pipes/string-to-array.pipe';
import { MockV3BookingDataService } from '@app/app/shared/services/bookings/mock-v3-booking-data.service';
import {
  ApiV3BookingDataService,
  V3BookingDataService,
  V3_BOOKING_DATA_SERVICE,
} from '@app/app/shared/services/bookings/v3-booking-data.service';
import { ApiContentLinkService } from '@app/app/shared/services/content-link/api-content-link.service';
import { PORTFOLIO_DATA_SERVICE } from '@app/app/shared/services/portfolio/data.service';
import { RestClientService } from '@app/app/shared/services/rest-client.service';
import { SHARED_UPCOMING_DATA_SERVICE } from '@app/app/shared/services/upcoming/upcoming-data.service';
import * as SharedFactoryService from '@app/app/shared/shared-service-factory';
import { V3WorkspacesNavComponent } from '@app/app/shared/side-nav-tree/v3-workspaces-nav/v3-workspaces-nav.component';
import { StyleguideModule } from '@app/app/shared/styleguide/styleguide.module';
import { environment } from '@app/environments/environment';
import { TranslocoService } from '@ngneat/transloco';
import { NgxsModule } from '@ngxs/store';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { ResizableModule } from 'angular-resizable-element';
import { QRCodeModule } from 'angularx-qrcode';
import { NgChartsModule } from 'ng2-charts';
import { ImageCropperModule } from 'ngx-image-cropper';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { TinyMceEditorDirective } from '../editor/components/editor-content-view/editor-content/tinymce-editor/tinymce-editor-dir/tinymce-editor.dir';
import { AdminMembersControlPanelComponent } from '../page-modules/admin/components/members/admin-member-control-panel/admin-member-control-panel.component';
import { AlumniCsvUploadDialogComponent } from '../page-modules/admin/components/members/admin-member-control-panel/alumni-csv-upload-dialog/alumni-csv-upload-dialog.component';
import { EditGroupDialogComponent } from '../page-modules/admin/components/members/admin-member-control-panel/edit-group-dialog/edit-group-dialog.component';
import { EditRoleDialogComponent } from '../page-modules/admin/components/members/admin-member-control-panel/edit-role-dialog/edit-role-dialog.component';
import { ImportUsersDialogComponent } from '../page-modules/admin/components/members/admin-member-control-panel/import-users-dialog/import-users-dialog.component';
import { UsersCsvUploadDialogComponent } from '../page-modules/admin/components/members/admin-member-control-panel/users-csv-upload-dialog/users-csv-upload-dialog.component';
import { UsersCsvUploadErrorsDialogComponent } from '../page-modules/admin/components/members/admin-member-control-panel/users-csv-upload-errors-dialog/users-csv-upload-errors-dialog.component';
import { AdminMemberListComponent } from '../page-modules/admin/components/members/admin-member-list/admin-member-list.component';
import { AdminMemberTableComponent } from '../page-modules/admin/components/members/admin-member-list/admin-member-table/admin-member-table.component';
import { AdminMembersComponent } from '../page-modules/admin/components/members/members.component';
import { ApiUnsplashImagesDataService } from '../page-modules/admin/services/images/api-unsplash-images-data.service';
import { DiagnosticsReportConditionalSectionComponent } from '../page-modules/diagnostics/components/view/diagnostics-view-report/conditional-section/conditional-section.component';
import { DiagnosticsReportConditionalSectionViewComponent } from '../page-modules/diagnostics/components/view/diagnostics-view-report/diagnostics-report-conditional-section-view/diagnostics-report-conditional-section-view.component';
import { DiagnosticsViewReportDialogComponent } from '../page-modules/diagnostics/components/view/diagnostics-view-report/report-dialog/report-dialog.component';
import { DiagnosticsReportResourceSectionCardComponent } from '../page-modules/diagnostics/components/view/diagnostics-view-report/resource-section/resource-section-card/resource-section-card.component';
import { DiagnosticsReportResourceSectionComponent } from '../page-modules/diagnostics/components/view/diagnostics-view-report/resource-section/resource-section.component';
import { DiagnosticsReportStandardSectionComponent } from '../page-modules/diagnostics/components/view/diagnostics-view-report/standard-section/standard-section.component';
import { SegmentBarComponent } from '../page-modules/diagnostics/components/view/segment-bar/segment-bar.component';
import { AchievementsSectionComponent } from '../page-modules/folio/components/view/shared/achievements-section/achievements-section.component';
import { FolioMasonryCardComponent } from '../page-modules/folio/components/view/shared/masonry-section/folio-masonry-card/folio-masonry-card.component';
import { MasonryActionButtonComponent } from '../page-modules/folio/components/view/shared/masonry-section/masonry-action-button/masonry-action-button.component';
import { MasonryCardComponent } from '../page-modules/folio/components/view/shared/masonry-section/masonry-card/masonry-card.component';
import { MasonryTextCardComponent } from '../page-modules/folio/components/view/shared/masonry-section/masonry-text-card/masonry-text-card.component';
import { DiscoveryPageHeadComponent } from '../page-modules/pages/components/discovery/discovery-page-head/discovery-page-head.component';
import { PageSummaryComponent } from '../page-modules/pages/components/edit/summary/summary.component';
import { PagesTargetAudienceComponent } from '../page-modules/pages/components/edit/target-audience/target-audience.component';
import { ContentSectionViewComponent } from '../page-modules/pages/components/page-view/content-section-view/content-section-view.component';
import { FeaturedSectionViewComponent } from '../page-modules/pages/components/page-view/featured-section-view/featured-section-view.component';
import { PageCategoriesSectionComponent } from '../page-modules/pages/components/page-view/page-categories-section/page-categories-section.component';
import { PageFrameworkTrackerSectionComponent } from '../page-modules/pages/components/page-view/page-framework-tracker-section/page-framework-tracker-section.component';
import { PageTableauSectionComponent } from '../page-modules/pages/components/page-view/page-tableau-section/page-tableau-section.component';
import { ShareDialogComponent } from '../page-modules/pages/components/view/share-dialog/share-dialog.component';
import { PersonalIndicatorBigSixChartComponent } from '../page-modules/personality-indicator/pi-charts/pi-big-six-chart/pi-big-six-chart.component';
import { PersonalIndicatorJungianChartComponent } from '../page-modules/personality-indicator/pi-charts/pi-jungian-chart/pi-jungian-chart.component';
import { PersonalIndicatorSpectrumChartComponent } from '../page-modules/personality-indicator/pi-charts/pi-spectrum-chart/pi-spectrum-chart.component';
import { PersonalIndicatorTeamRoleChartComponent } from '../page-modules/personality-indicator/pi-charts/pi-team-role-chart/pi-team-role-chart.component';
import { PersonalIndicatorTraitChartComponent } from '../page-modules/personality-indicator/pi-charts/pi-trait-chart/pi-trait-chart.component';
import { PlaylistCardRequiredIconComponent } from '../page-modules/playlist/shared/create/cards-section/required-icon/playlist-card-required-icon.component';
import { WebLinkCardEditorComponent } from '../page-modules/playlist/shared/create/new-web-link-card-dialog/web-link-card-editor/web-link-card-editor.component';
import { ReviewState } from '../page-modules/playlist/store/create/review/review.state';
import { QuizDialogComponent } from '../page-modules/resource/components/view/quizzes/quiz-dialog/quiz-dialog.component';
import { QuizResultsDialogComponent } from '../page-modules/resource/components/view/quizzes/quiz-results-dialog/quiz-results-dialog.component';
import { QuizResultsReportComponent } from '../page-modules/resource/components/view/quizzes/quiz-results-report/quiz-results-report.component';
import { UpcomingEventListComponent } from '../page-modules/upcoming/components/content/upcoming-event-list/upcoming-event-list.component';
import { UpcomingEventComponent } from '../page-modules/upcoming/components/content/upcoming-event-list/upcoming-event/upcoming-event.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';
import { BreadcrumbsModule } from './breadcrumbs/breadcrumbs.module';
import { FormEvidenceEditorComponent } from './components-v3/form-content-elements/form-evidence/form-evidence-editor.component';
import { AddFrameworkTagsComponent } from './components/add-framework-tags/add-framework-tags.component';
import { FrameworkCreateComponent } from './components/add-framework-tags/create-framework/framework-create.component';
import { DisableTagPipe } from './components/add-framework-tags/framework-pipes/DisableTagPipe';
import { FrameworkTagsListTreeComponent } from './components/add-framework-tags/framework-tags-list-tree/framework-tags-list-tree.component';
import { FrameworkTagsListComponent } from './components/add-framework-tags/framework-tags-list/framework-tags-list.component';
import { FrameworksListComponent } from './components/add-framework-tags/frameworks-list/frameworks-list.component';
import { AddLanguageSettingsComponent } from './components/add-language-settings/add-language-settings.component';
import { AddLinkDialogComponent } from './components/add-link-dialog/add-link-dialog.component';
import { AddPageTemplateComponent } from './components/add-page-template/add-page-template.component';
import { AddTagsComponent } from './components/add-tags/add-tags.component';
import { AdminSidebarSectionComponent } from './components/admin-sidebar-section/admin-sidebar-section.component';
import { AdminSidebarComponent } from './components/admin-sidebar/admin-sidebar.component';
import { AlertComponent } from './components/alert/alert.component';
import { CalendarIntegrationPromptComponent } from './components/calendar-integration-prompt/calendar-integration-prompt.component';
import { DiagnosticsViewChoiceQuestionTypeComponent } from './components/choice-question-type/choice-question-type.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { CoverImageUploadDialogComponent } from './components/cover-image-upload-dialog/cover-image-upload-dialog.component';
import { DataCollectionDialogComponent } from './components/data-collection/data-collection-dialog/data-collection-dialog.component';
import { DataFormsDialogComponent } from './components/data-forms/data-forms-dialog/data-forms-dialog.component';
import { GroupListDropDownComponent } from './components/data-forms/data-forms-dialog/group-list-drop-down/group-list-drop-down.component';
import { GroupListComponent } from './components/data-forms/data-forms-dialog/group-list-drop-down/group-list/group-list.component';
import { DataFormsErrorComponent } from './components/data-forms/data-forms-error/data-forms-error.component';
import { DiagnosticsViewGridQuestionTypeComponent } from './components/diagnostics-view-grid-question-type/diagnostics-view-grid-question-type.component';
import { DiagnosticsViewDragDropQuestionTypeComponent } from './components/drag-drop-question-type/drag-drop-question-type.component';
import { EmbedConsentPlaceholderComponent } from './components/embed-consent-placeholder/embed-consent-placeholder.component';
import { EventCardsDateComponent } from './components/event-date/event-date.component';
import { FileUploadDialogComponent } from './components/file-upload-dialog/file-upload-dialog.component';
import { ActivityDateFilterComponent } from './components/filters/activity-date-filter/activity-date-filter.component';
import { AttendanceFilterComponent } from './components/filters/attendance-filter/attendance-filter.component';
import { CompletionFilterComponent } from './components/filters/completion-filter/completion-filter.component';
import { FilterBtnComponent } from './components/filters/filter-btn/filter-btn.component';
import { GroupFilterComponent } from './components/filters/group-filter/group-filter.component';
import { NameFilterComponent } from './components/filters/name-filter/name-filter.component';
import { ReviewStatusFilterComponent } from './components/filters/review-status-filter/review-status-filter.component';
import { RoleFilterComponent } from './components/filters/role-filter/role-filter.component';
import { SubmissionDateFilterComponent } from './components/filters/submission-date-filter/submission-date-filter.component';
import { V3ActivityDateFilterComponent } from './components/filters/v3/v3-activity-date-filter/v3-activity-date-filter.component';
import { V3AttendanceFilterComponent } from './components/filters/v3/v3-attendance-filter/v3-attendance-filter.component';
import { V3CompletionFilterComponent } from './components/filters/v3/v3-completion-filter/v3-completion-filter.component';
import { V3FilterShellComponent } from './components/filters/v3/v3-filter-shell/v3-filter-shell.component';
import { V3GroupFilterComponent } from './components/filters/v3/v3-group-filter/v3-group-filter.component';
import { V3ReviewStatusFilterComponent } from './components/filters/v3/v3-review-status-filter/v3-review-status-filter.component';
import { V3RoleFilterComponent } from './components/filters/v3/v3-role-filter/v3-role-filter.component';
import { GroupSearchAutocompleteComponent } from './components/group-search-autocomplete/group-search-autocomplete.component';
import { HeadersEditorComponent } from './components/headers-editor/headers-editor.component';
import { HelpCenterComponent } from './components/help-center/help-center.component';
import { ImageCropDialogComponent } from './components/image-crop-dialog/image-crop-dialog.component';
import { LanguageTabsComponent } from './components/language-tabs/language-tabs.component';
import { CardFooterComponent } from './components/layout/card-footer/card-footer.component';
import { CardProgressCircleComponent } from './components/layout/card-progress-circle/card-progress-circle.component';
import { CardProgressComponent } from './components/layout/card-progress/card-progress.component';
import { FavoriteButtonComponent } from './components/layout/favorite-button/favorite-button.component';
import { FavoriteNewButtonComponent } from './components/layout/favorite-new-button/favorite-new-button.component';
import { LikeInfoNewComponent } from './components/layout/like-info-new/like-info-new.component';
import { LikeInfoComponent } from './components/layout/like-info/like-info.component';
import { LinkDialogComponent } from './components/link-dialog/link-dialog.component';
import { DataLoadErrorComponent } from './components/loadable-content/data-load-error-panel/data-load-error-panel.component';
import { LoadableContentComponent } from './components/loadable-content/loadable-content.component';
import { LoaderComponent } from './components/loader/loader.component';
import { TinyMediumEditorComponent } from './components/medium-editor/medium-editor.component';
import { OptimizedImageLoaderComponent } from './components/optimized-image-loader/optimized-image-loader.component';
import { PlaylistFeaturedCardComponent } from './components/playlist-featured-card/playlist-featured-card.component';
import { PlaylistFeaturedLinkComponent } from './components/playlist-featured-link/playlist-featured-link.component';
import { PrintPageFooterComponent } from './components/print-page/print-page-footer/print-page-footer.component';
import { ProfileImageComponent } from './components/profile-image/profile-image.component';
import { ProgressBarUploadComponent } from './components/progress-bar-upload/progress-bar-upload.component';
import { QRCodeComponent } from './components/qr-code/qr-code.component';
import { ResourceAudioPreviewComponent } from './components/resource-preview/audio-preview/audio-preview.component';
import { BarChartPreviewComponent } from './components/resource-preview/chart-preview/bar-chart/bar-chart-preview.component';
import { ChartPreviewComponent } from './components/resource-preview/chart-preview/chart-preview.component';
import { ResourceDocumentPreviewComponent } from './components/resource-preview/document-preview/document-preview.component';
import { ExternalPreviewComponent } from './components/resource-preview/external-preview/external-preview.component';
import { CollectorReviewComponent } from './components/resource-preview/form-preview/collector-review/collector-review.component';
import { AddFromMomentsDialogComponent } from './components/resource-preview/form-preview/form-collector-preview/add-from-moments-dialog/add-from-moments-dialog.component';
import { FormCollectorPreviewComponent } from './components/resource-preview/form-preview/form-collector-preview/form-collector-preview.component';
import { CollectorDetailDialogComponent } from './components/resource-preview/form-preview/form-collector-preview/form-collector-table/collector-detail-dialog/collector-detail-dialog.component';
import { FormCollectorTableComponent } from './components/resource-preview/form-preview/form-collector-preview/form-collector-table/form-collector-table.component';
import { FormConnectedTextboxComponent } from './components/resource-preview/form-preview/form-connected-textbox/form-connected-textbox.component';
import { PortfolioFormPreviewComponent } from './components/resource-preview/form-preview/form-portfolio-preview/form-portfolio-preview.component';
import { ResourceFormPreviewComponent } from './components/resource-preview/form-preview/form-preview.component';
import { ProjectFormPreviewComponent } from './components/resource-preview/form-preview/form-project-preview/form-project-preview.component';
import { FormQuestionPreviewComponent } from './components/resource-preview/form-preview/form-question-preview/form-question-preview.component';
import { FormPreviewQuizComponent } from './components/resource-preview/form-preview/form-quiz/form-preview-quiz.component';
import { FormPreviewTextboxComponent } from './components/resource-preview/form-preview/form-textbox/form-textbox.component';
import { FormReviewEventsListComponent } from './components/resource-preview/form-preview/form-update-footer/form-review-events-list/form-review-events-list.component';
import { FormUpdateFooterComponent } from './components/resource-preview/form-preview/form-update-footer/form-update-footer.component';
import { ResourceHtmlPreviewComponent } from './components/resource-preview/html-preview/html-preview.component';
import { ResourceImagePreviewComponent } from './components/resource-preview/image-preview/image-preview.component';
import { MediaUploadImagePreviewComponent } from './components/resource-preview/image-preview/media-upload-image-preview/media-upload-image-preview.component';
import { ResourcePreviewComponent } from './components/resource-preview/preview.component';
import { ResourceStreamVideoPreviewComponent } from './components/resource-preview/stream-video-preview/stream-video-preview.component';
import { V3ResourceAudioPreviewComponent } from './components/resource-preview/v3-audio-preview/v3-audio-preview.component';
import { ResourceVideoPreviewComponent } from './components/resource-preview/video-preview/video-preview.component';
import { ReviewEventComponent } from './components/review-event/review-event.component';
import { ReviewStatusComponent } from './components/review-status/review-status.component';
import { RoleSearchAutocompleteComponent } from './components/role-search-autocomplete/role-search-autocomplete.component';
import { SecondarySidebarComponent } from './components/secondary-sidebar/secondary-sidebar.component';
import { SidebarExpandableChildrenComponent } from './components/sidebar-expandable-children/sidebar-expandable-children.component';
import { SidebarSectionsComponent } from './components/sidebar-sections/sidebar-sections.component';
import { SkeletonActionItemComponent } from './components/skeleton-view/skeleton-action-item/skeleton-action-item.component';
import { SkeletonAppointmentListItemComponent } from './components/skeleton-view/skeleton-appointment-list-item/skeleton-appointment-list-item.component';
import { SkeletonEventItemComponent } from './components/skeleton-view/skeleton-event-item/skeleton-event-item.component';
import { SkeletonListItemComponent } from './components/skeleton-view/skeleton-list-item/skeleton-list-item.component';
import { SkeletonPageItemComponent } from './components/skeleton-view/skeleton-page-item/skeleton-page-item.component';
import { SkeletonReportListItemComponent } from './components/skeleton-view/skeleton-report-list-item/skeleton-report-list-item.component';
import { SkeletonTableItemComponent } from './components/skeleton-view/skeleton-table-item/skeleton-table-item.component';
import { SkeletonTableSmallItemComponent } from './components/skeleton-view/skeleton-table-small-item/skeleton-table-small-item.component';
import { SkeletonViewComponent } from './components/skeleton-view/skeleton-view.component';
import { SocialShareUrlComponent } from './components/social-share/social-share-url.component';
import { StorePagesCardComponent } from './components/store-pages-card/store-pages-card.component';
import { ToastContainerComponent } from './components/toast-notifications/toast-container.component';
import { ToastComponent } from './components/toast-notifications/toast/toast.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TwoFactorSetupComponent } from './components/two-factor-setup/two-factor-setup.component';
import { UnsplashImagesSearchBoxComponent } from './components/unsplash-images-search-box/unsplash-images-search-box.component';
import { UserSearchAutocompleteNewComponent } from './components/user-search-autocomplete-new/user-search-autocomplete-new.component';
import { UserSearchAutocompleteComponent } from './components/user-search-autocomplete/user-search-autocomplete.component';
import { VideoUploadDialogComponent } from './components/video-upload-dialog/video-upload-dialog.component';
import { OptionsScrollDirective } from './directives/autocomplete-scroll.directive';
import { BetaFeatureDirective, NotBetaFeatureDirective } from './directives/beta-feature.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ConditionalBetaFeatureDirective } from './directives/conditional-beta-feature.directive';
import { CopyTextDirective } from './directives/copy-text.directive';
import { FileDropDirective } from './directives/file-drop.directive';
import { ImageFallbackDirective } from './directives/image-fallback.directive';
import { ImageSourceDirective } from './directives/image-source.directive';
import { LongPressDirective } from './directives/long-press.directive';
import { MasonryDirective } from './directives/masonry.directive';
import { ScrollNearEndDirective } from './directives/scroll-near-end.directive';
import { ToolbarTooltipComponent } from './editor-js/components/toolbar-tooltip/toolbar-tooltip.component';
import { MediumEditorDirective } from './medium-editor/medium-editor.directive';
import { ArraySortPipe } from './pipes/array-sort.pipe';
import { GetDataByLangCodePipe } from './pipes/data-by-language-code.pipe';
import { PictureNamePipe } from './pipes/file-name-from-url.pipe';
import { FolioCardTimeAgoPipe } from './pipes/label-time-ago.pipe';
import { ReviewStatusPipe } from './pipes/review-status.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SingularPluralNounPipe } from './pipes/singular-plural-noun.pipe';
import { SmartDateFormatPipe } from './pipes/smart-date.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { UpperFirstPipe } from './pipes/upper-first.pipe';
import { UrlifyTextPipe } from './pipes/urlify-text.pipe';
import { ApiSharedReviewDataService } from './services/review/api-review-data.service';
import { ApiSidebarTreeDataService } from './services/sidebar-tree/api-sidebar-tree-data.service';
import { AdminsSideNavComponent } from './side-nav-tree/admins-side-nav/admins-side-nav.component';
import { SideNavTreeMainComponent } from './side-nav-tree/main-side-nav-tree/main-side-nav-tree.component';
import { MobileMenuSideNavComponent } from './side-nav-tree/mobile-menu-side-nav/mobile-menu-side-nav.component';
import { SideNavTreeItemComponent } from './side-nav-tree/side-nav-tree-item/side-nav-tree-item.component';
import { SideNavTreeSectionComponent } from './side-nav-tree/side-nav-tree-section/side-nav-tree-section.component';
import { SideNavState } from './side-nav-tree/store/side-nav.state';
import { V3AdminsSideNavComponent } from './side-nav-tree/v3-admins-side-nav/v3-admins-side-nav.component';
import { WorkspacesNavComponent } from './side-nav-tree/workspaces-nav/workspaces-nav.component';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ManageJobsDialogComponent } from '@app/app/page-modules/admin/components/mentors/manage-jobs-dialog/manage-jobs-dialog.component';
import { EmbedpdfAnnotationEditorComponent } from '@app/app/page-modules/pdf-annotation-editor';
import { CardItemListViewComponent } from '@app/app/shared/collections/card-item/card-item-list-view/card-item-list-view.component';
import { CardItemMainViewComponent } from '@app/app/shared/collections/card-item/card-item-main-view/card-item-main-view.component';
import { CardItemSnakeViewComponent } from '@app/app/shared/collections/card-item/card-item-snake-view/card-item-snake-view.component';
import { CardItemComponent } from '@app/app/shared/collections/card-item/card-item.component';
import { CollectionCardsViewComponent } from '@app/app/shared/collections/collection-cards-view/collection-cards-view.component';
import { CollectionsLayoutViewComponent } from '@app/app/shared/collections/collections-layout-view/collections-layout-view.component';
import { ContentItemAuthorComponent } from '@app/app/shared/collections/content-item/author/content-item-author.component';
import { ContentItemControlPanelComponent } from '@app/app/shared/collections/content-item/control-panel/content-item-control-panel.component';
import { EngagementCardComponent } from '@app/app/shared/collections/content-item/engagement-card/engagement-card.component';
import { ContentItemImageComponent } from '@app/app/shared/collections/content-item/image/content-item-image.component';
import { ContentItemProgressComponent } from '@app/app/shared/collections/content-item/progress/content-item-progress.component';
import { ContentLanguageMenuComponent } from '@app/app/shared/components-v3/content-language-menu/content-language-menu.component';
import { V3EmptyStateComponent } from '@app/app/shared/components-v3/empty-state/v3-empty-state.component';
import { CardImageComponent } from '@app/app/shared/components/card-placeholder-image/card-image.component';
import { PtlDatePipe } from '@app/app/shared/pipes/ptl-date.pipe';
import { SidebarItemBaseComponent } from '@app/app/shared/styleguide/components/buttons/sidebar-item-base/sidebar-item-base.component';
import { ColorPickerModule } from 'ngx-color-picker';

const COMPONENTS = [
  LoadableContentComponent,
  LoaderComponent,
  DataLoadErrorComponent,
  SideNavTreeMainComponent,
  SideNavTreeSectionComponent,
  SideNavTreeItemComponent,
  AdminsSideNavComponent,
  V3AdminsSideNavComponent,
  WorkspacesNavComponent,
  V3WorkspacesNavComponent,
  MobileMenuSideNavComponent,
  ResourcePreviewComponent,
  ResourceHtmlPreviewComponent,
  ResourceDocumentPreviewComponent,
  ResourceFormPreviewComponent,
  ProfileImageComponent,
  MediaUploadImagePreviewComponent,
  ResourceImagePreviewComponent,
  ResourceVideoPreviewComponent,
  ResourceStreamVideoPreviewComponent,
  ResourceAudioPreviewComponent,
  TinyMediumEditorComponent,
  MediumEditorDirective,
  TinyMceEditorDirective,
  CopyTextDirective,
  FormUpdateFooterComponent,
  FormReviewEventsListComponent,
  FormPreviewTextboxComponent,
  FormPreviewPrivateNoteComponent,
  FormPreviewCheckboxComponent,
  FormPreviewFileUploadComponent,
  FormCollectorPreviewComponent,
  FormCollectorTableComponent,
  FormAiAssistantComponent,
  CollectorDetailDialogComponent,
  AddFromMomentsDialogComponent,
  CollectorReviewComponent,
  ChartPreviewComponent,
  RadarChartPreviewComponent,
  BarChartPreviewComponent,
  PolarChartPreviewComponent,
  SkeletonViewComponent,
  SkeletonBadgeComponent,
  SkeletonListItemComponent,
  SkeletonReportListItemComponent,
  HeadersEditorComponent,
  WebLinkCardEditorComponent,
  SkeletonActionItemComponent,
  SkeletonAppointmentListItemComponent,
  BadgeImageComponent,
  SkeletonEventItemComponent,
  SkeletonSmallCardItemComponent,
  SkeletonTableItemComponent,
  SkeletonTableSmallItemComponent,
  OptimizedImageLoaderComponent,
  MasonryDirective,
  ExternalPreviewComponent,
  ImageCropDialogComponent,
  ConfirmationDialogComponent,
  CalendarIntegrationPromptComponent,
  AdvancedImageCropDialogComponent,
  PaginationBlockComponent,
  PaginationComponent,
  AddFrameworkTagsComponent,
  AddFrameworkTagsDialogComponent,
  FrameworkTagsListComponent,
  FrameworksListComponent,
  FrameworkCreateComponent,
  FrameworkTagsListTreeComponent,
  ImageSourceDirective,
  FormPreviewQuizComponent,
  FormPreviewBookingComponent,
  DiagnosticsViewGridQuestionTypeComponent,
  DiagnosticsViewDragDropQuestionTypeComponent,
  DiagnosticsViewChoiceQuestionTypeComponent,
  DiagnosticsViewGroupQuestionTypeComponent,
  DiagnosticsViewListQuestionTypeComponent,
  MasonryCardComponent,
  MasonryTextCardComponent,
  MasonryActionButtonComponent,
  ContentSectionViewComponent,
  PageFrameworkTrackerSectionComponent,
  PageTableauSectionComponent,
  PageCategoriesSectionComponent,
  DiscoveryPageHeadComponent,
  FeaturedSectionViewComponent,
  PlaylistFeaturedCardComponent,
  PlaylistFeaturedLinkComponent,
  UpcomingEventCardComponent,
  UpcomingEventListComponent,
  UpcomingEventComponent,
  StorePagesCardComponent,
  AchievementsSectionComponent,
  SkeletonPageItemComponent,
  SkeletonPagesItemComponent,
  AdminMembersComponent,
  V3AdminMembersComponent,
  AdminMemberTableComponent,
  MemberInfoDialogComponent,
  V3MemberInfoDialogComponent,
  AdminAddMemberComponent,
  AdminMemberListComponent,
  AdminMembersControlPanelComponent,
  V3AdminMembersControlPanelComponent,
  V3InviteMemberComponent,
  V3TargetAudienceSectionComponent,
  AudienceChipListComponent,
  V3AdminActionButtonsComponent,
  V3AdminMemberTableComponent,
  V3AdminMemberListComponent,
  EditRoleDialogComponent,
  EditGroupDialogComponent,
  AlumniCsvUploadDialogComponent,
  UsersCsvUploadDialogComponent,
  UsersCsvUploadErrorsDialogComponent,
  QuizDialogComponent,
  QuizResultsDialogComponent,
  QuizResultsReportComponent,
  DataCollectionDialogComponent,
  PlaylistCardRequiredIconComponent,
  LikeInfoComponent,
  LikeInfoNewComponent,
  CardFooterComponent,
  FavoriteButtonComponent,
  FavoriteNewButtonComponent,
  CardProgressComponent,
  CardProgressCircleComponent,
  PrintPageFooterComponent,
  PersonalIndicatorTraitChartComponent,
  PersonalIndicatorTeamRoleChartComponent,
  PersonalIndicatorBigSixChartComponent,
  PersonalIndicatorSpectrumChartComponent,
  PersonalIndicatorJungianChartComponent,
  LanguageTabsComponent,
  ShareDialogComponent,
  RoleSearchAutocompleteComponent,
  UserSearchAutocompleteComponent,
  UserSearchAutocompleteNewComponent,
  MemberSearchAutocompleteComponent,
  MenteeSearchAutocompleteComponent,
  StudentSearchAutocompleteComponent,
  GroupSearchAutocompleteComponent,
  PageSummaryComponent,
  PageAnalyticsComponent,
  PlaylistMetricsTableDialogComponent,
  EventSearchComponent,
  PagesTargetAudienceComponent,
  DataFormsDialogComponent,
  ControlPanelFilterChipsComponent,
  GroupListComponent,
  GroupListDropDownComponent,
  TooltipComponent,
  HelpCenterComponent,
  ReviewStatusComponent,
  ReviewEventComponent,
  ToastComponent,
  ToastContainerComponent,
  FilterBtnComponent,
  ExportBtnComponent,
  NameFilterComponent,
  GroupFilterComponent,
  RoleFilterComponent,
  ActivityDateFilterComponent,
  AttendanceFilterComponent,
  SubmissionDateFilterComponent,
  ReviewStatusFilterComponent,
  CompletionFilterComponent,
  V3FilterShellComponent,
  V3GroupFilterComponent,
  V3RoleFilterComponent,
  V3ActivityDateFilterComponent,
  V3AttendanceFilterComponent,
  V3CompletionFilterComponent,
  V3ReviewStatusFilterComponent,
  QRCodeComponent,
  LongPressDirective,
  UnsplashImagesSearchBoxComponent,
  DataFormsErrorComponent,
  SocialShareUrlComponent,
  ShareBadgeUrlComponent,
  ShareEventComponent,
  PublicBadgeContentComponent,
  AddLanguageSettingsComponent,
  DateRangePickerComponent,
  DailyEnrollmentChartComponent,
  DailyViewsChartComponent,
  DeviceTypeChartComponent,
  MostCompletionsChartComponent,
  CompletionUserCountChartComponent,
  CourseEngagementsChartComponent,
  MostEngagementsChartComponent,
  MostEngagedUsersChartComponent,
  MostActiveViewersChartComponent,
  AnalyticsHelpComponent,
  MentorMenteeTableComponent,
  JobsTimelineDialogComponent,
  ManageJobsDialogComponent,
  DiagnosticsViewReportDialogComponent,
  DiagnosticsViewReportDialog360Component,
  DiagnosticsReportStandardSectionComponent,
  DiagnosticsReportResourceSectionComponent,
  DiagnosticsReportConditionalSectionComponent,
  DiagnosticsReportConditionalSectionViewComponent,
  ReportTopActionsComponent,
  FeedbackStatsSectionComponent,
  FeedbackProvidersSectionComponent,
  EditableSectionTitleComponent,
  StatsSectionComponent,
  QuestionsSectionComponent,
  QuestionAnswerChoiceComponent,
  ChoiceResultsTablePreviewComponent,
  QuestionAnswerSliderComponent,
  QuestionAnswerTextComponent,
  ProvidersSectionComponent,
  ResultsRangeChartComponent,
  FeedbackQuestionSectionComponent,
  SegmentBarComponent,
  DiagnosticsReportResourceSectionCardComponent,
  CoverImageUploadDialogComponent,
  CustomSelectComponent,
  VideoUploadDialogComponent,
  MentorSearchDialogComponent,
  AddPageTemplateComponent,
  AddTagsComponent,
  ImportUsersDialogComponent,
  AlertComponent,
  FormConnectedTextboxComponent,
  ToolbarTooltipComponent,
  FormQuestionPreviewComponent,
  EventCardsDateComponent,
  EventCardsRemindersComponent,
  FolioMasonryCardComponent,
  V3FolioMasonryCardComponent,
  V3FolioMasonryCardTagsComponent,
  ProgressBarUploadComponent,
  EventCardsTicketsComponent,
  DiagnosticsViewSliderQuestionTypeComponent,
  DatapointSelectionDialogComponent,
  LinkDialogComponent,
  AddLinkDialogComponent,
  FileUploadDialogComponent,
  PlaylistReportComponent,
  PlaylistPrintReportComponent,
  FileUploadDialogComponent,
  FileDropzoneComponent,
  ReviewCommentPreviewComponent,
  PortfolioFormPreviewComponent,
  ProjectFormPreviewComponent,
  SimpleBarChartComponent,
  SimpleHorizontalBarChartComponent,
  SimplePieChartComponent,
  AudioRecorderComponent,
  VideoRecorderComponent,
  AdminSidebarComponent,
  AdminSidebarSectionComponent,
  SecondarySidebarComponent,
  SidebarSectionsComponent,

  CardItemComponent,
  ContentItemImageComponent,
  ContentItemProgressComponent,
  ContentItemAuthorComponent,
  ContentItemControlPanelComponent,
  EngagementCardComponent,
  CollectionsLayoutViewComponent,
  CollectionCardsViewComponent,
  TwoFactorSetupComponent,
];

const DIRECTIVES = [BetaFeatureDirective, NotBetaFeatureDirective, OptionsScrollDirective, ConditionalBetaFeatureDirective];

const PIPES = [
  SingularPluralNounPipe,
  GetDataByLangCodePipe,
  ReviewStatusPipe,
  PictureNamePipe,
  UpperFirstPipe,
  UrlifyTextPipe,
  DisableTagPipe,
  ArraySortPipe,
  TruncatePipe,
  StringToArrayPipe,
  CamelToReadablePipe,
  IsNonEmptyEditorContentPipe,
  FolioCardTimeAgoPipe,
];

const STANDALONE_COMPONENTS = [
  V3ResourceAudioPreviewComponent,
  DatePickerComponent,
  SidebarExpandableChildrenComponent,
  CardItemSnakeViewComponent,
  CardItemMainViewComponent,
  CardItemListViewComponent,
  ImageFallbackDirective,
  CompetencyScaleComponent,
  AnimateOnScrollDirective,
];
const STANDALONE_PIPES = [SmartDateFormatPipe, DateFormatPipe, SafeHtmlPipe];

SwiperCore.use([Navigation, Pagination]);

@NgModule({
  declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
  imports: [
    MembersReIndexButtonComponent,
    ScrollNearEndDirective,
    EmbedConsentPlaceholderComponent,
    ContentLanguageMenuComponent,
    PtlDatePipe,
    NgxsModule.forFeature([SideNavState, ReviewState]),
    TranslocoRootModule,
    CommonModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    MatCardModule,
    MatButtonModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatStepperModule,
    MatNativeDateModule,
    RouterModule,
    ImageCropperModule,
    BreadcrumbsModule,
    MatDialogModule,
    MatDialogModuleV3,
    MatCheckboxModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    NgChartsModule,
    MatTabsModule,
    TranslocoRootModule,
    MatDividerModule,
    MatExpansionModule,
    EditorComponent,
    QRCodeModule,
    SwiperModule,
    ResizableModule,
    MatTableModule,
    MatSortModule,
    MatListModule,
    StyleguideModule,
    ...STANDALONE_COMPONENTS,
    ...STANDALONE_PIPES,
    EmbedpdfAnnotationEditorComponent,
    PdfPagesRendererComponent,
    CardImageComponent,
    ColorPickerModule,
    FileDropDirective,
    SidebarItemBaseComponent,
    ClickOutsideDirective,
    V3EmptyStateComponent,
    FormEvidenceEditorComponent,
  ],
  exports: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
    BreadcrumbsModule,
    StyleguideModule,
    ...STANDALONE_COMPONENTS,
    ...STANDALONE_PIPES,
    FileDropDirective,
    ClickOutsideDirective,
    ScrollNearEndDirective,
    V3EmptyStateComponent,
    ContentLanguageMenuComponent,
  ],
  providers: [
    ApiUnsplashImagesDataService,
    ApiSharedReviewDataService,
    ApiSidebarTreeDataService,
    ApiLtiCourseBadgeDataService,
    ApiContentLinkService,
    {
      provide: MENTOR_MENTEE_DATA_SERVICE,
      useFactory: SharedFactoryService.mentorMenteeServiceFactory,
      deps: [RestClientService, TranslocoService],
    },
    {
      provide: SHARED_UPCOMING_DATA_SERVICE,
      useFactory: SharedFactoryService.upcomingServiceFactory,
      deps: [RestClientService, TranslocoService],
    },
    {
      provide: MEMBERS_DATA_SERVICE,
      useFactory: SharedFactoryService.membersServiceFactory,
      deps: [RestClientService, TranslocoService],
    },
    {
      provide: REVIEWS_DATA_SERVICE,
      useFactory: SharedFactoryService.reviewsDataServiceFactory,
      deps: [RestClientService, TranslocoService],
    },
    {
      provide: V3_BOOKING_DATA_SERVICE,
      useFactory: v3BookingDataServiceFactory,
      deps: [RestClientService, TranslocoService],
    },
    {
      provide: PORTFOLIO_DATA_SERVICE,
      useFactory: SharedFactoryService.portfolioServiceFactory,
      deps: [RestClientService, TranslocoService],
    },
  ],
})
export class SharedModule {}

export function v3BookingDataServiceFactory(client: RestClientService, translocoService: TranslocoService): V3BookingDataService {
  if (environment.dataProvider === 'mock') {
    return new MockV3BookingDataService();
  }

  return new ApiV3BookingDataService(client, translocoService);
}
